"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MedicalHistoryController = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const platform_express_1 = require("@nestjs/platform-express");
const multer_1 = require("multer");
const path_1 = require("path");
const fs_1 = require("fs");
const medical_history_service_1 = require("./medical-history.service");
const medical_doc_entity_1 = require("./medical-doc.entity");
const notifications_service_1 = require("../notifications/notifications.service");
const notification_log_entity_1 = require("../notifications/notification-log.entity");
const jwt_auth_guard_1 = require("../../common/guards/jwt-auth.guard");
const permissions_guard_1 = require("../../common/guards/permissions.guard");
const permissions_decorator_1 = require("../../common/decorators/permissions.decorator");
const current_user_decorator_1 = require("../../common/decorators/current-user.decorator");
const user_entity_1 = require("../users/user.entity");
const permissions_1 = require("../authorization/permissions");
const UPLOAD_DIR = (0, path_1.join)(process.cwd(), 'uploads', 'medical');
const ALLOWED_EXTS = ['.pdf', '.jpg', '.jpeg', '.png', '.webp'];
const MAX_SIZE_MB = 10;
let MedicalHistoryController = class MedicalHistoryController {
    constructor(medicalHistoryService, notificationsService) {
        this.medicalHistoryService = medicalHistoryService;
        this.notificationsService = notificationsService;
    }
    frontendBase(frontendUrl) {
        return frontendUrl ?? process.env['FRONTEND_PUBLIC_URL'] ?? 'http://localhost:4200';
    }
    findAll(customerId) {
        return this.medicalHistoryService.findAll(customerId);
    }
    findOne(id) {
        return this.medicalHistoryService.findById(id);
    }
    /** Multipart file upload — saves file to disk and creates MedicalDoc record */
    async uploadDoc(file, body, user) {
        if (!file)
            throw new common_1.BadRequestException('No file uploaded');
        const apiBase = process.env['API_PUBLIC_URL'] ?? `http://localhost:${process.env.API_PORT || 3000}/api`;
        const fileUrl = `${apiBase}/uploads/medical/${file.filename}`;
        return this.medicalHistoryService.create({
            customerId: Number(body.customerId),
            docType: body.docType || medical_doc_entity_1.DocType.OTHER,
            fileName: file.originalname,
            fileUrl,
            fileExtension: (0, path_1.extname)(file.originalname).replace('.', '').toLowerCase(),
            notes: body.notes,
            uploadedById: user.id,
        });
    }
    create(body, user) {
        return this.medicalHistoryService.create({ ...body, uploadedById: user.id });
    }
    setValidity(id, body) {
        return this.medicalHistoryService.setValidity(id, new Date(body.validUntil));
    }
    deactivate(id) {
        return this.medicalHistoryService.deactivate(id);
    }
    async generateUploadLink(body, user) {
        const frontendBase = this.frontendBase(body.frontendUrl);
        const link = await this.medicalHistoryService.generateUploadLink(Number(body.customerId), body.docType ?? medical_doc_entity_1.DocType.OTHER, body.notes);
        const uploadUrl = `${frontendBase}/medical-upload/${link.token}`;
        const selectedChannels = (body.channels ?? [])
            .map((channel) => channel.toLowerCase())
            .filter((channel) => Object.values(notification_log_entity_1.NotificationChannel).includes(channel));
        let notifications = [];
        if (selectedChannels.length > 0) {
            const sendOpts = {
                channels: selectedChannels,
                to: {
                    phone: body.phone,
                    email: body.email,
                    name: body.customerName,
                    customerId: Number(body.customerId),
                },
                template: notification_log_entity_1.NotificationTemplate.DOC_UPLOAD_REQUEST,
                variables: {
                    customerName: body.customerName ?? 'Customer',
                    uploadLink: uploadUrl,
                },
                referenceId: Number(body.customerId),
                referenceType: 'customer',
                sentById: user.id,
            };
            notifications = await this.notificationsService.send(sendOpts);
        }
        return {
            token: link.token,
            uploadUrl,
            expiresAt: link.expiresAt,
            requestedDocType: link.requestedDocType,
            files: link.files ?? [],
            notifications,
        };
    }
};
exports.MedicalHistoryController = MedicalHistoryController;
tslib_1.__decorate([
    (0, common_1.Get)(),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.MEDICAL_HISTORY_READ),
    tslib_1.__param(0, (0, common_1.Query)('customerId', common_1.ParseIntPipe)),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number]),
    tslib_1.__metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
], MedicalHistoryController.prototype, "findAll", null);
tslib_1.__decorate([
    (0, common_1.Get)(':id'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.MEDICAL_HISTORY_READ),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number]),
    tslib_1.__metadata("design:returntype", typeof (_d = typeof Promise !== "undefined" && Promise) === "function" ? _d : Object)
], MedicalHistoryController.prototype, "findOne", null);
tslib_1.__decorate([
    (0, common_1.Post)('upload'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.MEDICAL_HISTORY_UPLOAD),
    (0, common_1.UseInterceptors)((0, platform_express_1.FileInterceptor)('file', {
        storage: (0, multer_1.diskStorage)({
            destination: (_req, _file, cb) => {
                if (!(0, fs_1.existsSync)(UPLOAD_DIR))
                    (0, fs_1.mkdirSync)(UPLOAD_DIR, { recursive: true });
                cb(null, UPLOAD_DIR);
            },
            filename: (_req, file, cb) => {
                const unique = `${Date.now()}-${Math.round(Math.random() * 1e6)}`;
                cb(null, `${unique}${(0, path_1.extname)(file.originalname).toLowerCase()}`);
            },
        }),
        limits: { fileSize: MAX_SIZE_MB * 1024 * 1024 },
        fileFilter: (_req, file, cb) => {
            const ext = (0, path_1.extname)(file.originalname).toLowerCase();
            if (ALLOWED_EXTS.includes(ext))
                cb(null, true);
            else
                cb(new common_1.BadRequestException(`File type not allowed. Allowed: ${ALLOWED_EXTS.join(', ')}`), false);
        },
    })),
    tslib_1.__param(0, (0, common_1.UploadedFile)()),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__param(2, (0, current_user_decorator_1.CurrentUser)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [typeof (_f = typeof Express !== "undefined" && (_e = Express.Multer) !== void 0 && _e.File) === "function" ? _f : Object, Object, typeof (_g = typeof user_entity_1.User !== "undefined" && user_entity_1.User) === "function" ? _g : Object]),
    tslib_1.__metadata("design:returntype", typeof (_h = typeof Promise !== "undefined" && Promise) === "function" ? _h : Object)
], MedicalHistoryController.prototype, "uploadDoc", null);
tslib_1.__decorate([
    (0, common_1.Post)(),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.MEDICAL_HISTORY_CREATE),
    tslib_1.__param(0, (0, common_1.Body)()),
    tslib_1.__param(1, (0, current_user_decorator_1.CurrentUser)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, typeof (_j = typeof user_entity_1.User !== "undefined" && user_entity_1.User) === "function" ? _j : Object]),
    tslib_1.__metadata("design:returntype", typeof (_k = typeof Promise !== "undefined" && Promise) === "function" ? _k : Object)
], MedicalHistoryController.prototype, "create", null);
tslib_1.__decorate([
    (0, common_1.Patch)(':id/validity'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.MEDICAL_HISTORY_SET_VALIDITY),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object]),
    tslib_1.__metadata("design:returntype", typeof (_l = typeof Promise !== "undefined" && Promise) === "function" ? _l : Object)
], MedicalHistoryController.prototype, "setValidity", null);
tslib_1.__decorate([
    (0, common_1.Delete)(':id'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.MEDICAL_HISTORY_DELETE),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number]),
    tslib_1.__metadata("design:returntype", typeof (_m = typeof Promise !== "undefined" && Promise) === "function" ? _m : Object)
], MedicalHistoryController.prototype, "deactivate", null);
tslib_1.__decorate([
    (0, common_1.Post)('upload-link'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.MEDICAL_HISTORY_UPLOAD),
    tslib_1.__param(0, (0, common_1.Body)()),
    tslib_1.__param(1, (0, current_user_decorator_1.CurrentUser)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, typeof (_o = typeof user_entity_1.User !== "undefined" && user_entity_1.User) === "function" ? _o : Object]),
    tslib_1.__metadata("design:returntype", Promise)
], MedicalHistoryController.prototype, "generateUploadLink", null);
exports.MedicalHistoryController = MedicalHistoryController = tslib_1.__decorate([
    (0, common_1.UseGuards)(jwt_auth_guard_1.JwtAuthGuard, permissions_guard_1.PermissionsGuard),
    (0, common_1.Controller)('medical-history'),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof medical_history_service_1.MedicalHistoryService !== "undefined" && medical_history_service_1.MedicalHistoryService) === "function" ? _a : Object, typeof (_b = typeof notifications_service_1.NotificationsService !== "undefined" && notifications_service_1.NotificationsService) === "function" ? _b : Object])
], MedicalHistoryController);
